export default {
      id: "flex-alignItems-center-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignItems-center-usage",
      toString: function () {
        return this.url;
      }
    }